module.exports = __webpack_public_path__ + "static/media/ICONO HYGIENE MONITORING.c6689f0b.svg";